<template>
  <v-progress-linear indeterminate v-if="initialising"></v-progress-linear>
  <v-container v-else
               :class="{'mt-0 pt-0': $vuetify.breakpoint.xs, 'mt-12': $vuetify.breakpoint.smAndUp, 'mb-12 pb-12': true}">
    <v-layout column wrap align-content-center justify-center>
      <v-card max-width="720" width="100vw">
        <v-toolbar color="secondary" dark flat>
          <v-tabs v-model="subView"
                  align-with-title
                  background-color="transparent">
            <v-tabs-slider color="primary"></v-tabs-slider>

            <v-tab v-for="item in views" :key="item.name">
              <v-icon>{{ item.icon }}</v-icon>
            </v-tab>
          </v-tabs>
          <v-spacer></v-spacer>
          <v-toolbar-title :class="{'mr-8':$vuetify.breakpoint.smAndUp, 'flex-shrink-0':true}">
            Your {{ views[subView].name }}
          </v-toolbar-title>

        </v-toolbar>
        <v-tabs-items v-model="subView">
          <v-tab-item v-for="item in views" :key="item.name" >
            <component :is="item.component" @done="refresh"></component>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  import SubscriptionStops from "./SubscriptionStops";

  export default {
    data: () => ({
      initialising: true,
      subView: 0,
      views: [
        {
          icon: "flag",
          name: "Stops",
          component: SubscriptionStops,
        }
      ]
    }),
    computed: {
      user() {
        return this.$store.state.user;
      },
      //mapData() {
      //  return this.$store.state.mapData;
      //},
      subscriptions() {
        return this.$store.state.subscriptions;
      },
    },
    methods: {
        refresh() {
        return this.$store.dispatch("getSubscriptions")
          .catch(e => {
            if (e.status == 401 || e.status == 403) {
              this.$router.push({ path: "/login", query: { redirect: this.$router.currentRoute.fullPath } });
            }
          }).then(state => {
            if (this.$cookies.isKey("new-sub-stop")) {
                this.$store.commit("addSubscription", { platformTag: +this.$cookies.get("new-sub-stop"), fromCookie: true, localId: Date.now() });
            }
            return true;
          });
      },
    },
    mounted() {
      Promise.all([
       // this.$store.dispatch("getMapData"),
        this.$store.dispatch("getContactMethods"),
        this.refresh()
      ]).then(() => {
         // console.log(this.mapData);
        this.initialising = false;
      });
    }
  };
</script>
